module.exports = "<p>\n  pss works!\n</p>\n"